/**
 * App path helpers. Use object locations for queries so React Router
 * replaces search instead of appending another "?".
 */

export const REGISTER_TO = {
  pathname: '/login',
  search: '?mode=register',
};

/** Product app home. Guests can browse; login is asked on execute. */
export const APP_HOME = '/dashboard';

/** Upload hub (rebuild from file or ATS report). Kept for bookmarks. */
export const FROM_FILE = '/dashboard/from-file';

/** Primary product path: upload → AI rewrite → studio. */
export const REWRITE = '/dashboard/quick-edit';

/** Keep original design, rewrite text only. */
export const KEEP_LOOK = '/dashboard/keep-look';

/** Off until the Canva/PDF overlay is ready to show users. */
export const KEEP_LOOK_ENABLED = false;

/** ATS report only (no new PDF). */
export const ATS_UPLOAD = '/dashboard/upload';

/** After Google/email activation, land on the ATS dropzone. */
export const POST_SIGNUP = ATS_UPLOAD;
